module.exports = __webpack_public_path__ + "img/arrow-down-blue-used.a36b7bf0.svg";